import { AgencyGroupListItem } from '../../../integrated-client/models'

export interface IAgencyGroupEditorData {
  agencyGroupData?: AgencyGroupListItem
  validation?: any
}
export class AgencyGroupEditorData implements IAgencyGroupEditorData {

  agencyGroupData?: AgencyGroupListItem
  validation?: any
}